module.exports = __webpack_public_path__ + "static/media/gu.2dc35d7c.svg";